import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import AdaWidget from '~/layout/components/AdaWidget';
import { CustomerDetailNames } from '~/shared/constants/customerDetailNames';
import { Link } from '~/techstyle-shared/next-routes';
import { useCustomerDetail } from '~/techstyle-shared/react-accounts';

import { createDataAutoTagString } from '../header/utils/createDataAutoTagString';
import { getBuilderDataAnalyticsProps } from '../header/utils/getBuilderDataAnalyticsProps';

const FooterLinkWrapper = styled.li`
  list-style: none;
`;

const StyledLink = styled.a`
  width: 100%;

  ${({ theme }) => theme.builderFooter.footerLink.link}
`;

const Label = styled.span`
  display: inline-block;
  font-size: 14px;

  ${({ theme }) => theme.builderFooter.footerLink.label}

  ${({ $isBold, theme }) => $isBold && theme.builderFooter.footerLink.bold}
`;

const OneTrustLink = styled.span`
  font-size: 14px;
  cursor: pointer;
  display: inline-block;

  ${({ theme }) => theme.builderFooter.footerLink.oneTrust}
`;

const OneTrustButton = styled.div`
  display: none;
`;

function getFooterLink({
  cookieSetting,
  dataAutotag,
  isAccessibilityOption,
  isBold,
  isFaqLink,
  isOneTrust,
  linkText,
  linkUrl,
  membershipPriceTestDetailRecord,
  settingClick,
}) {
  if (isAccessibilityOption) {
    return (
      <AdaWidget
        data-ga-label="Footer_Memberservices_enableaccessibility"
        data-autotag={dataAutotag}
      >
        {linkText}
      </AdaWidget>
    );
  } else if (isFaqLink && membershipPriceTestDetailRecord?.value) {
    const url = new URL(linkUrl);
    url.searchParams.append('tsps', '69.95');
    linkUrl = url.toString();
  } else if (isOneTrust) {
    return (
      <>
        <OneTrustLink data-autotag={dataAutotag} onClick={settingClick}>
          {linkText}
        </OneTrustLink>
        <OneTrustButton>
          <button
            type="button"
            ref={cookieSetting}
            id="ot-sdk-btn"
            className="ot-sdk-show-settings"
          />
        </OneTrustButton>
      </>
    );
  }

  return (
    <Link href={linkUrl} passHref>
      <StyledLink title={linkText}>
        <Label $isBold={isBold}>{linkText}</Label>
      </StyledLink>
    </Link>
  );
}

function BuilderFooterLink({
  linkText,
  linkUrl,
  isAccessibilityOption,
  isBold,
  isFaqLink,
  isOneTrust,
  dataAnalytics,
}) {
  const membershipPriceTestDetailRecord = useCustomerDetail(
    CustomerDetailNames.M13_PERKS_2025
  );
  const dataAutotag = dataAnalytics?.label
    ? createDataAutoTagString(dataAnalytics.label)
    : createDataAutoTagString(linkText);
  const cookieSetting = useRef(null);

  const settingClick = () => {
    cookieSetting.current.click();
  };

  return (
    <FooterLinkWrapper
      data-builder-component-type="nav_link"
      data-autotag={dataAutotag}
      {...getBuilderDataAnalyticsProps(dataAnalytics)}
    >
      {getFooterLink({
        cookieSetting,
        dataAutotag,
        isAccessibilityOption,
        isBold,
        isFaqLink,
        isOneTrust,
        linkText,
        linkUrl,
        membershipPriceTestDetailRecord,
        settingClick,
      })}
    </FooterLinkWrapper>
  );
}

BuilderFooterLink.propTypes = {
  dataAnalytics: PropTypes.shape({
    category: PropTypes.string,
    label: PropTypes.string,
  }),
  isAccessibilityOption: PropTypes.bool,
  isBold: PropTypes.bool,
  isFaqLink: PropTypes.bool,
  isOneTrust: PropTypes.bool,
  linkText: PropTypes.string,
  linkUrl: PropTypes.string,
};

export default BuilderFooterLink;
